import { render, staticRenderFns } from "./nimp_background_selector.vue?vue&type=template&id=19515b04&scoped=true&"
import script from "./nimp_background_selector.vue?vue&type=script&lang=js&"
export * from "./nimp_background_selector.vue?vue&type=script&lang=js&"
import style0 from "./nimp_background_selector.vue?vue&type=style&index=0&id=19515b04&scoped=true&lang=css&"
import style1 from "./nimp_background_selector.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19515b04",
  null
  
)

export default component.exports